/** Bank-enterprise direct connection (bankJournal module) */
export default {
  bankJournalPage: {
    confirmTitle: 'Notice',
    confirmOk: 'OK',
    confirmCancel: 'Cancel',
    confirmApprove: 'Approve this action?',
    phDateStart: 'Start',
    phDateEnd: 'End',
    phTenant: 'Tenant name / ID',
    phStatus: 'Status',
    phBankType: 'Bank',
    phSelect: 'Select',
    phInput: 'Enter',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    sectionTenantTitle: 'Bank link · Tenant top-up',
    sortDefault: 'Default sort',
    colSeqNo: 'Transaction no.',
    colPayeeName: 'Remitter name',
    colBankNumber: 'Remitter account no.',
    colAmountYuan: 'Amount (CNY)',
    colReceivAccount: 'Payee company',
    colReceivAccountNum: 'Payee account no.',
    colOpeningBank: 'Bank branch',
    colRecvBank: 'Receiving bank',
    colRemark: 'Transfer note',
    colTenantId: 'Tenant ID',
    colTenantName: 'Tenant name',
    colTime: 'Time',
    colType: 'Type',
    colStatus: 'Status',
    colAction: 'Actions',
    btnProcess: 'Process',
    btnVoid: 'Void',
    msgLoadFail: 'Failed to load',
    msgConfirmVoid: 'Mark this record as void?',
    msgVoidOk: 'Voided',
    msgNoExportData: 'Nothing to export',
    exportSheetName: 'Tenant top-up',
    exportFilePrefixCurrentPage: 'TenantTopUp_Page',
    bankBankOfChina: 'Bank of China',
    bankPufa: 'SPD Bank',
    bankBocDigital: 'BOC Digital Technology',
    bankCmb: 'China Merchants Bank',
    bankNbAsset: 'Bank of Ningbo (asset)',
    statusPending: 'Pending',
    statusDone: 'Completed',
    statusVoided: 'Voided',
    statusRefunding: 'Refunding',
    statusRefunded: 'Refunded',
    typeCharge: 'Top-up',
    typeRefund: 'Refund',
    dialogAuditTitle: 'Process',
    lblPayeeName: 'Remitter name',
    lblBankNumber: 'Remitter account no.',
    lblAmountYuan: 'Amount (CNY)',
    lblSeqNo: 'Transaction no.',
    lblTenantPick: 'Tenant name / ID',
    phSearchTenant: 'Search or select tenant',
    bizPickTitle: 'Select posting wallet',
    bizPickDesc: 'This tenant has both {electric} and {water}. Choose a card below for where to post this transfer; electricity is selected by default.',
    accountElectricLedger: 'Electricity wallet',
    accountWaterLedger: 'Water wallet',
    cardElectricDesc: 'For prepaid electricity meters and electricity balance.',
    cardWaterDesc: 'For prepaid water meters and water balance.',
    rechargeTypeTitle: 'Top-up type',
    singleMeterOnly: 'This tenant only has an electricity wallet; this payment will post to the electricity account.',
    singleWaterOnly: 'This tenant only has a water wallet; this payment will post to the water account.',
    alertNoMeterWaterAccount: 'No electricity or water wallet was found for this tenant. Please verify tenant data before processing.',
    selectTenantFirstHint: 'Select a tenant from the dropdown above first.',
    btnCancel: 'Cancel',
    btnConfirm: 'Confirm',
    msgBankMatchFail: 'Failed to load matching tenants',
    msgTenantWalletFail: 'Failed to load tenant wallet info',
    msgPickTenant: 'Please select a tenant',
    msgNoWalletBook: 'This tenant has no electricity/water wallet; cannot post',
    msgPickRechargeType: 'Please select a top-up type',
    msgOpSuccess: 'Done',
    dialogRefundTitle: 'Corporate refund',
    lblRefundAmount: 'Refund amount (CNY)',
    lblRecvAccount: 'Payee name',
    lblRecvAccountNum: 'Payee account no.',
    lblPayoutDate: 'Payout date',
    lblRefundReason: 'Refund reason',
    btnFeishuSubmit: 'Submit Feishu approval',
    rulePayoutDate: 'Select payout date',
    ruleRefundReason: 'Enter refund reason',
    msgFeishuApplyFail: 'Feishu request failed',
    msgSubmitted: 'Submitted',
    drawerAdvancedFilter: 'Advanced filters',
    lblTenantNameNo: 'Tenant name / ID',
    phTenantNameOrNo: 'Tenant name or ID',
    lblRecvSubAccount: 'Receiving account no.',
    lblRemitterAccount: 'Remitter name',
    lblRemitterBankNo: 'Remitter account no.',
    lblState: 'Status',
    lblBankKind: 'Bank',
    lblDateRange: 'Date'
  }
}
